<template>
  <div v-if="selectedSupplierProduct">
    <v-card elevation="19" tile>
      <v-card-title   class="text-h5"
          
       >
        جزئیات شناسنامه/محصول/ کالا/خدمت: 
      </v-card-title>
      <v-card-subtitle  class="text-h5" v-text=" selectedSupplierProduct.name   "></v-card-subtitle>
      
      <v-spacer></v-spacer>
      <span> </span>
    </v-card>
    <v-divider></v-divider>

    <v-row class="mx-3" v-if="selectedSupplierProduct">
      <v-col cols="12" sm="6" md="4" v-if="selectedSupplierProduct.name">
        <label for="">نام : </label>
        <strong>{{ selectedSupplierProduct.name }}</strong>
      </v-col>
      <v-col cols="12" sm="6" md="4" v-if="breadcrumb">
        <label for="">پیکربندی : </label>
        <strong>{{ breadcrumb }}</strong>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <label for="">وضعیت :</label>
        <strong>{{
          selectedSupplierProduct.adminConfirmed ? 'تائید شده' : 'بررسی نشده '
        }}</strong>
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="4"
        v-if="selectedSupplierProduct.supplierSummary"
      >
        <label for="">خلاصه:</label>
        <strong>{{ selectedSupplierProduct.supplierSummary }}</strong>
      </v-col>
      <v-col cols="12" v-if="selectedSupplierProduct.supplierDescription">
        <label for="">شرح  : </label>
        <strong v-html="selectedSupplierProduct.supplierDescription"></strong>
      </v-col>
      <v-col
        cols="12"
        v-if="
          selectedSupplierProduct.productProperties &&
          selectedSupplierProduct.productProperties.length > 0
        "
      >
        <v-card outlined>
          <v-card-title>ویزگیهای پایه</v-card-title>
          <v-card-text>
            <show-properties
              :properties="selectedSupplierProduct.productProperties"
            ></show-properties>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        v-if="
          selectedSupplierProduct.properties &&
          selectedSupplierProduct.properties.length > 0
        "
      >
        <v-card outlined>
          <v-card-title>ویژگیهای اختصاصی تامین کننده</v-card-title>
          <v-card-text>
            <show-properties
              :properties="selectedSupplierProduct.properties"
            ></show-properties>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        v-if="
          selectedSupplierProduct.propertySuggestions &&
          selectedSupplierProduct.propertySuggestions.length > 0
        "
      >
        <v-card v-if="selectedSupplierProduct.propertySuggestions.length>0" outlined>
          <v-card-title>مشخصات پیشنهادی تامین کننده</v-card-title>
          <v-card-text>
            <v-row>
              <v-col
                cols="12"
                sm="6"
                v-for="(
                  property, index
                ) in selectedSupplierProduct.propertySuggestions"
                :key="index"
              >
                <v-row>
                  <v-col cols="12" sm="12">
                    <b>{{ property.title }} </b></v-col
                  >
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        v-if="
          selectedSupplierProduct.supplierImages &&
          selectedSupplierProduct.supplierImages.length > 0
        "
      >
        <label for=""> تصاویر :</label>
        <div class="d-flex flex-row flex-warp">
          <div
            v-for="(image, index) in selectedSupplierProduct.supplierImages"
            :key="index"
            class="mx-2"
          >
            <v-img
              width="160"
              height="90"
              :src="image.thumbnailFileUrl"
              :alt="image.alt"
              @click="openImage(image.fileUrl)"
            ></v-img>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="error" @click="clseSupplierProductDetail">بستن</v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import { RepoFactory } from '@/baseRepository/Factory';
const categoryRepository = RepoFactory.get('category');
import Helper from '@/core/helpers';
import ShowProperties from '@/components/core/showProperties.vue';
export default {
  components: {
    ShowProperties,
  },
  props: {
    categoryType: {
      type: String,
      default: null,
    },
    id: {
      type: String,
      default: null,
    },
    selectedSupplierProduct: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      breadcrumb: null,
    };
  },
  computed: {
    productBaseUrl() {
      return this.$store.getters.productBaseUrl;
    },
    merchantId() {
      return this.$store.getters.currentMerchant;
    },
  },
  created() {
    if (this.selectedSupplierProduct) this.getMerchantCategoriesBreadCrumb();
  },
  methods: {
    clseSupplierProductDetail() {
      this.$router.push({
        path: `/supplier-products/${this.categoryType}`,
      });
    },
    openImage(url) {
      window.open(url, '_blank');
    },
    getMerchantCategoriesBreadCrumb() {
      const loader = this.$loading.show();
      let params = {
        categoryTypeItems: this.categoryType,
      };
      categoryRepository
        .getMerchantCategoriesBreadCrumb(
          this.productBaseUrl,
          {
            MerchantId: this.$store.getters.currentMerchant,
          },
          params
        )
        .then((res) => {
          res.data.forEach((categoty) => {
            if (
              categoty.categoryId == this.selectedSupplierProduct.categoryId
            ) {
              this.breadcrumb = categoty.breadcrumb;
            }
          });
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => {
          loader.hide();
        });
    },
  },
};
</script>

<style></style>
